/* eslint-disable react/prop-types */
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { Box, TableCell, TableRow } from "@mui/material";
import React from "react";
import moment from "moment";
import tableStyle from "../../theme/styles/table";
import { getGohonzonType } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import { style } from "./styles";

function GohonzonReturnVerification({
  member,
  onMemberSelect,
  returnVerificationSubmit,
  onRejectApplication,
}) {
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }
  const { memberDetails } = member;

  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {memberDetails.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>{member.districtName || "-"}</TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType)}
      </TableCell>
      <TableCell style={{ ...style.Cell }}>
        <Box style={style.status}>{member.statusValue}</Box>
      </TableCell>
      <TableCell style={style.Cell}>
        {member.appliedBy || "-"}
        <br />
        {/* {member.appliedAt !== null ? moment(member.appliedAt).format("L") : "-"} */}
        {member.appliedAt ? moment(member.appliedAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={style.flexC}>
          <RemoveRedEyeOutlinedIcon
            style={style.icon}
            onClick={() => onMemberSelect(member.memberId, "return/preview")}
          />
          <Box style={{ ...style.ActionBtnContainer }}>
            <Button
              variant="outlined"
              style={{ ...style.actionBtn, marginBottom: "10px" }}
              label="Verify"
              onClick={() => returnVerificationSubmit(member)}
            />
            <Button
              variant="outlined"
              onClick={() => onRejectApplication(member)}
              style={style.actionBtn}
              label="Cancel"
            />
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonReturnVerification;
